import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import CommonHeadingNBtns from "../../../components/common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../../components/components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { add_gym_plans, update_gym_plans } from "../../../data/ApiEndpoints";

const UpdateGymPlans = ({
  userInfoData,
  isEdit,
  rowData,
  closeModal,
  prevCloseModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    planPrice: isEdit && rowData?.plan_price ? rowData.plan_price : "",
    extendableDays: isEdit && rowData?.extend_days ? rowData.extend_days : "",
    isActive: isEdit && rowData?.status === "inactive" ? false : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : type === "file" ? file : value,
    }));
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.planPrice) {
      errors.planPrice = "Required!";
    }

    return errors;
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_gym_plans : add_gym_plans;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        prevCloseModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        uid: isEdit ? rowData?.uid || "" : "",
        type_id: isEdit ? "" : rowData?.plan_uid || "",
        plan_price: formValues.planPrice || "",
        extend_days: formValues.extendableDays || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        isEdit
          ? `You want to update the amount of ₹${rowData?.plan_price || 0} of ${
              rowData?.type || ""
            } plan to ₹${formValues.planPrice || 0}!`
          : `You want to add the amount of ₹${
              formValues.planPrice || 0
            } to plan ${rowData?.plan_name || ""}`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add New"} Plan Price`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="planPrice" className={`formInputLabel `}>
              plan price <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Amount"
              className={`formInput ${
                formErrors?.planPrice ? "formError" : ""
              }`}
              name="planPrice"
              value={formValues.planPrice}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="extendableDays" className={`formInputLabel `}>
              extendable days
            </label>

            <input
              type="text"
              placeholder="Enter No. Of Days"
              className={`formInput ${
                formErrors?.extendableDays ? "formError" : ""
              }`}
              name="extendableDays"
              value={formValues.extendableDays}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateGymPlans;
